import React, { useEffect } from "react";
import { Messages } from "primereact/messages";
import { Toast } from "primereact/toast";
import { Message } from "./Message";

export interface MessageSummaryProps {
  message: Message | null;
  onRemove: (message: Message) => void;
}

export const MessageSummary: React.FC<MessageSummaryProps> = (props) => {
  let messagesRef = React.createRef<Messages>();
  let toastRef = React.createRef<Toast>();

  const showMessage = (message: Message) => {
    if (message.toastify || !messagesRef.current) return;

    messagesRef.current.show(message);
  };

  const showToast = (message: Message) => {
    if (!message.toastify || !toastRef.current) return;

    toastRef.current.show(message);
  };

  useEffect(() => {
    const message = props.message;
    if (!message) return;

    showMessage(message);
    showToast(message);
  });

  if (!props.message) return null;

  return (
    <div>
      <Messages ref={messagesRef} onRemove={props.onRemove} />
      <Toast ref={toastRef} onRemove={props.onRemove} />
    </div>
  );
};
